<template>
    <div class="txd__fields">
        <div class="txd__field txd__field--wide">
            <span class="txd__label">{{ $t('frontend_groovesell_transaction_table_funnel_name') }}</span>
            <span class="txd__value">{{ selectedTransaction.funnel_name }}</span>
        </div>
        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_product_name') }}</span>
            <span class="txd__value">{{ selectedTransaction.product_name }}</span>
        </div>
        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_price_point') }}</span>
            <span class="txd__value">{{ selectedTransaction.price_point_name }}</span>
        </div>

        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_type') }}</span>
            <span class="txd__value">{{ selectedTransaction.transaction_type }}</span>
        </div>
        <div class="txd__field">
            <span class="txd__label">{{ isCancellationRecord ? 'Reference amount' : $t('frontend_analytics_revenue') }}</span>
            <span class="txd__value">{{ selectedTransaction.human_readable_price }}</span>
        </div>

        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_gateway') }}</span>
            <span class="txd__value">{{ selectedTransaction.gateway }}</span>
        </div>
        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_account') }}</span>
            <span class="txd__value">{{ selectedTransaction.gateway_name }}</span>
        </div>

        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_transaction_id_gateway') }}</span>
            <span v-if="selectedTransaction.processor_transaction_id" class="txd__value txd__value--mono">{{ selectedTransaction.processor_transaction_id }}</span>
            <span v-else class="txd__value txd__value--empty">—</span>
        </div>
        <div class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_date_and_time') }}</span>
            <span class="txd__value">{{ selectedTransaction.formatted_date_time }}</span>
        </div>

        <div v-if="!isCancellationRecord" class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_refund_period') }}</span>
            <span class="txd__value">
                {{
                    selectedTransaction.product &&
                    selectedTransaction.product != null
                    ? selectedTransaction.product.refund_period
                    : 'NA'
                }}
                {{ $t('frontend_analytics_days') }}
            </span>
        </div>
        <div class="txd__field">
            <span class="txd__label">{{ isCancellationRecord ? 'Previous recurring bill' : $t('frontend_analytics_recurring_bill') }}</span>
            <span v-if="selectedTransaction.recurring_billing" class="txd__value">{{ selectedTransaction.recurring_billing }}</span>
            <span v-else class="txd__value txd__value--empty">—</span>
        </div>

        <div v-if="!isCancellationRecord && selectedTransaction.recurring_billing &&
            selectedTransaction.payments_left &&
            selectedTransaction.payments_left != 99999999999" class="txd__field">
            <span class="txd__label">{{ $t('frontend_analytics_payments_left') }}</span>
            <span class="txd__value">{{ selectedTransaction.payments_left }}</span>
        </div>
        <div v-if="showDaysSinceFreeSignup" class="txd__field">
            <span class="txd__label">{{ $t('frontend_groovesell_transaction_days_since_free_signup') }}</span>
            <span class="txd__value">{{ selectedTransaction.days_since_free_signup }}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        isCancellationRecord: {
            type: Boolean,
            default: false,
        },
        selectedTransaction: {
            type: Object,
            required: true,
        },
        authenticatedUser: {
            default: null,
        },
    },
    computed: {
        showDaysSinceFreeSignup() {
            return this.authenticatedUser?.id === '5daeb623b256c50e25993cc6';
        },
    }
}
</script>
